export default "__VITE_ASSET__b4f6233a__"